export default __webpack_public_path__ + "static/media/diners.b64a61bb.png";